import * as React from 'react';
import { ThemeProvider } from 'styled-components';
import { GlobalStyles } from '../../../styles/GlobalStyles';

import { appTheme } from '../../../styles/theme';
import { HeaderSimple, Header, Footer, FooterSimple } from '../../navigations';
import { Flex } from '../../../components/blocks';
import styled from 'styled-components';

import '@fontsource/yakuhanjps';

type Props = {
  slim?: boolean;
  children: React.ReactNode;
  location?: string;
};

const Main = styled.main<Props>`
  width: 100%;
`;

export const Layout = (props: Props) => {
  return (
    <ThemeProvider theme={appTheme}>
      <Flex flexDirection="column" minHeight="100vh" width="100%">
        {props.slim === true ? <HeaderSimple /> : <Header />}
        <Main>{props.children}</Main>
        {props.slim === true ? <FooterSimple /> : <Footer />}
      </Flex>
      <GlobalStyles />
    </ThemeProvider>
  );
};
